import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { Styled } from "../utils";
import { WarningIcon } from "./icons";

export const WarningMessage = ({
  children,
  className,
}: PropsWithChildren<Styled>) => (
  <div className="flex items-center gap-2 bg-amber-400/20 px-2 py-3">
    <div className="flex h-fit">
      <WarningIcon className="text-amber-700" />
    </div>
    <p className={twMerge("text-sm leading-5 text-gray-70", className)}>
      {children}
    </p>
  </div>
);
